import React from "react";

/** Catches render/runtime errors in document/chat panels — shows service-unavailable copy. */
export default class ServiceErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (import.meta.env?.DEV) {
      console.error("ServiceErrorBoundary", error, info?.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-ds-xl border border-border bg-canvas-subtle p-6 text-sm text-fg-secondary" role="alert">
          <p className="font-semibold text-fg">Service temporarily unavailable</p>
          <p className="mt-2 text-xs">Try again later or use cached data where shown.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
